import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PORTAL_URL, PORTAL_LOGIN_URL } from '../config/links';
import './Navbar.css';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Training', path: '/training' },
  { label: 'Staff Augmentation', path: '/staff-augmentation' },
  { label: 'IT Services', path: '/it-services' },
  { label: 'Enterprise AI', path: '/enterprise-ai' },
  { label: 'Jobs', path: '/jobs' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

useEffect(() => { setMenuOpen(false); }, [location]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar" ref={menuRef}>
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img src="/logo.png" alt="ThirdEye Cybersecurity" className="brand-logo" />
          <div className="brand-text">
            <span className="brand-name">ThirdEye</span>
            <span className="brand-sub">Cybersecurity</span>
          </div>
        </Link>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map(link => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <a
              href={PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-portal-link"
            >
              Learning Portal <span aria-hidden="true">↗</span>
            </a>
          </li>
          <li>
            <a
              href={PORTAL_LOGIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-login"
            >
              Log In <span aria-hidden="true">↗</span>
            </a>
          </li>
          <li>
            <Link to="/contact" className="nav-cta">Contact Us</Link>
          </li>
        </ul>

        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
